import React, { useState, useRef, useCallback, useEffect } from 'react';
import styles from './ProductImageCarousel.module.css';

const PLACEHOLDER = 'https://via.placeholder.com/400x400?text=Sin+Imagen';

const ProductImageCarousel = ({ images = [], alt = 'Producto' }) => {
    const galleryImages =
        images.length > 0 ? images : [PLACEHOLDER];

    const [activeIndex, setActiveIndex] = useState(0);
    const trackRef = useRef(null);

    const updateIndexFromScroll = useCallback(() => {
        const track = trackRef.current;
        if (!track || track.offsetWidth === 0) return;

        const index = Math.round(track.scrollLeft / track.offsetWidth);
        setActiveIndex(Math.min(index, galleryImages.length - 1));
    }, [galleryImages.length]);

    useEffect(() => {
        setActiveIndex(0);
        if (trackRef.current) {
            trackRef.current.scrollLeft = 0;
        }
    }, [galleryImages]);

    const goToSlide = (index) => {
        const track = trackRef.current;
        if (!track) return;

        track.scrollTo({
            left: index * track.offsetWidth,
            behavior: 'smooth',
        });
        setActiveIndex(index);
    };

    const handleImageError = (e) => {
        e.target.onerror = null;
        e.target.src = PLACEHOLDER;
    };

    const hasMultiple = galleryImages.length > 1;

    return (
        <div className={styles.carousel}>
            <div
                ref={trackRef}
                className={styles.track}
                onScroll={updateIndexFromScroll}
                role="region"
                aria-label="Galería de fotos del producto"
            >
                {galleryImages.map((url, index) => (
                    <div key={`${url}-${index}`} className={styles.slide}>
                        <div className={styles.imageBorderContainer}>
                            <img
                                src={url}
                                alt={`${alt} - foto ${index + 1}`}
                                className={styles.slideImg}
                                draggable={false}
                                onError={handleImageError}
                            />
                        </div>
                    </div>
                ))}
            </div>

            {hasMultiple && (
                <>

                    <div className={styles.dots} aria-hidden="true">
                        {galleryImages.map((_, index) => (
                            <button
                                key={index}
                                type="button"
                                className={`${styles.dot} ${index === activeIndex ? styles.dotActive : ''
                                    }`}
                                onClick={() => goToSlide(index)}
                                aria-label={`Ver foto ${index + 1}`}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default ProductImageCarousel;
